// fileApiClient.ts
import axios from "axios";
import { doLogout } from "../utils/doLogout";
import { useAlertStore } from "../store/alertStore";
import config from "../config";

let isRefreshing = false;

const fileApiClient = axios.create({
  baseURL: config.front.url,
  timeout: 50000,
  // headers: {
  //   "Content-Type": "multipart/form-data",
  // },
  withCredentials: true,
});

fileApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && config.url !== "/members/login") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

fileApiClient.interceptors.response.use(
  (response) => {
    if (config.isDev) {
      console.log("fileApi response:", response);
    }
    return response;
  },
  async (error: any) => {
    if (config.isDev) {
      console.error("fileApi error:", error);
    }
    const originalRequest = error.config;
    const statusCode = error.response?.data?.statusCode;
    const message = error.response?.data?.message || "파일 업로드 중 오류가 발생했습니다.";

    if (statusCode === 461) {
      if (isRefreshing) {
        useAlertStore.getState().setAlert(message, "red");
        return Promise.reject(error);
      }

      isRefreshing = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          alert("세션이 만료되었습니다.");
          doLogout();
          return Promise.reject(error);
        }

        // 토큰 재발급 요청
        const res = await axios.post(`${config.api.url}/members/refresh`, {
          refresh_token: refreshToken,
        });

        const newAccessToken = res.data.data.access_token;
        const newRefreshToken = res.data.data.refresh_token;

        localStorage.setItem("token", newAccessToken);
        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }

        if (originalRequest.headers) {
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        }
        return fileApiClient(originalRequest);
      } catch (error: any) {
        alert("세션이 만료되었습니다.");
        doLogout();
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    } else {
      useAlertStore.getState().setAlert(message, "red");
    }

    return Promise.reject(error);
  }
);

export default fileApiClient;
